import { AlertCircle, CheckCircle, X } from 'lucide-react';
import { useToast } from '@/hooks/useToast';

/**
 * The one place toasts from `@/hooks/useToast` are drawn (Known Bugs #8).
 * Mounted once in main.tsx, above the router, so a save on any page shows
 * its confirmation. Bottom-left on phones (clear of Lite's bottom nav),
 * top-right on wider screens.
 */
export function GlobalToastViewport() {
  const { toasts, dismiss } = useToast();
  if (toasts.length === 0) return null;
  return (
    <div
      className="fixed bottom-20 left-4 right-4 sm:bottom-auto sm:left-auto sm:top-4 sm:right-4 z-[70] flex flex-col gap-2 sm:max-w-sm w-auto sm:w-full pointer-events-none"
      data-testid="global-toasts"
    >
      {toasts.map((t) => {
        const bad = t.variant === 'destructive';
        return (
          <div
            key={t.id}
            role="alert"
            className={`pointer-events-auto flex items-start gap-3 p-3.5 rounded-lg border shadow-lg animate-in slide-in-from-top-2 fade-in duration-200 ${
              bad
                ? 'bg-red-50 dark:bg-red-900/40 border-red-300 dark:border-red-700'
                : 'bg-white dark:bg-slate-800 border-slate-200 dark:border-slate-700'
            }`}
          >
            {bad ? (
              <AlertCircle className="w-5 h-5 flex-shrink-0 mt-0.5 text-red-600 dark:text-red-300" />
            ) : (
              <CheckCircle className="w-5 h-5 flex-shrink-0 mt-0.5 text-emerald-600 dark:text-emerald-400" />
            )}
            <div className="flex-1 min-w-0">
              <p
                className={`text-sm font-medium ${
                  bad
                    ? 'text-red-800 dark:text-red-100'
                    : 'text-slate-900 dark:text-white'
                }`}
              >
                {t.title}
              </p>
              {t.description && (
                <p className="text-xs text-slate-600 dark:text-slate-300 mt-0.5">
                  {t.description}
                </p>
              )}
            </div>
            <button
              type="button"
              onClick={() => dismiss(t.id)}
              aria-label="Dismiss"
              className="flex-shrink-0 p-1 rounded text-slate-400 hover:text-slate-600 dark:hover:text-slate-200"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
